// On browsers with no native BarcodeDetector (iOS Safari), this registers one
// backed by ZXing-C++ (WASM); `prepareZXingModule` configures where it loads.
import { prepareZXingModule } from 'barcode-detector/polyfill';
// Self-host the wasm (so it works offline / behind strict CSPs); `?url` makes
// Vite emit the file and give us its final hashed URL as a string.
import zxingReaderWasmUrl from 'zxing-wasm/reader/zxing_reader.wasm?url';

// Point the WASM loader at our self-hosted binary (default for everything else).
prepareZXingModule({
    overrides: {
        locateFile: (path, prefix) =>
            (path.endsWith('.wasm') ? zxingReaderWasmUrl : prefix + path),
    },
});
